import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  standalone: false,
})
export class ForbiddenComponent {
  public errorCode: string = '403';
  public errorTitle!: string;
  public errorDescription!: string;
  public quickTip!: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    getTranslation(this.translateService, ['403_title', '403_description', '403_quick_tip']).subscribe((t) => {
      this.errorTitle = t['403_title'];
      this.errorDescription = t['403_description'];
      this.quickTip = t['403_quick_tip'];
    });
  }
}
